/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";

function defaultSortFunction({ entities, property }) {
  return entities.sort(function (a, b) {
    const x = a[property];
    const y = b[property];
    return x < y ? -1 : x > y ? 1 : 0;
  });
}

function sortEntities({ sorting, sortFunction, entities }) {
  return sorting && sorting.property
    ? sortFunction({
      property: sorting.property,
      entities,
    })
    : entities;
}

function asSortable(WrappedComponent) {
  class SortableHOC extends React.Component {
    constructor(props, context) {
      super(props, context);
      const { sorting, entities, sortFunction } = this.props;
      this.state = {
        entities: sortEntities({ sorting, entities, sortFunction }),
        sorted: entities && entities.length > 0,
      };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.entities && nextProps.entities !== this.props.entities) {
        let newEntities = nextProps.entities;
        if (!this.state.sorted) {
          const { sorting, entities, sortFunction } = nextProps;
          newEntities = sortEntities({ sorting, entities, sortFunction });
        }
        this.setState({
          entities: newEntities,
          sorted: newEntities && newEntities.length > 0,
        });
      }
    }

    render() {
      const { entities } = this.state;
      const { entities: ignored, ...rest } = this.props;

      return <WrappedComponent entities={entities} {...rest} />;
    }
  }

  SortableHOC.defaultProps = {
    sortFunction: defaultSortFunction,
  };

  return SortableHOC;
}

export default asSortable;
